module.exports = __webpack_public_path__ + "static/iot.4346b069.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot.jpg
// module id = 845
// module chunks = 267660657819475